/* VÀLIEN — "Bilmekte fayda var" bloğu (rev.18)
   Nasıl Kullanılır kutusunun altına, açılır-kapanır üç kısa not ekler.
   İddia dili kuralı: süre yok, sonuç vaadi yok, oran yok. */
(function () {
  var ITEMS = [
    {
      q: 'Bu üründen ne beklemeli?',
      a: 'Bu ürün rutinde tek bir adımı karşılıyor; başlı başına bir rutin değil. Cilt bakımında belirleyici olan ürün değil süreklilik — düzenli kullanım, yüksek dozdan daha çok iş görüyor. Hızlı bir dönüşüm sözü vermiyoruz.'
    },
    {
      q: 'İlk kez mi kullanıyorsunuz?',
      a: 'Yeni bir ürüne başlarken kulak arkanızda veya çene hattınızda küçük bir alanda deneyin. Aynı hafta birden çok yeni ürüne başlamayın; cildiniz tepki verirse hangisine verdiğini ayırt edemezsiniz. Gün aşırı başlayıp cildiniz alıştıkça sıklığı artırın.'
    },
    {
      q: 'Ne kadar dayanır?',
      a: 'Ambalajın içeriği ürün adında yazıyor. Ne kadar dayanacağı kullanım sıklığınıza ve her seferde ne kadar kullandığınıza bağlı — bu yüzden bir süre söylemiyoruz. Ambalajın üzerindeki açıldıktan sonra kullanım süresi işaretine (6M, 12M gibi) bakın ve ürünü o süre içinde bitirin.'
    }
  ];

  function build() {
    if (document.querySelector('.vp-note')) return true;
    var steps = document.querySelector('.valien-product .vp-steps');
    if (!steps) return false;

    var wrap = document.createElement('div');
    wrap.className = 'vp-note';

    var label = document.createElement('div');
    label.className = 'vp-note__label';
    label.textContent = 'BİLMEKTE FAYDA VAR';
    wrap.appendChild(label);

    for (var i = 0; i < ITEMS.length; i++) {
      var d = document.createElement('details');
      d.className = 'vp-note__item';
      var s = document.createElement('summary');
      s.className = 'vp-note__q';
      s.textContent = ITEMS[i].q;
      var p = document.createElement('div');
      p.className = 'vp-note__a';
      p.textContent = ITEMS[i].a;
      d.appendChild(s);
      d.appendChild(p);
      wrap.appendChild(d);
    }

    steps.parentNode.insertBefore(wrap, steps.nextSibling);
    return true;
  }

  function run() {
    if (build()) return;
    var tries = 0;
    var t = setInterval(function () {
      tries++;
      if (build() || tries > 12) clearInterval(t);
    }, 700);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  document.addEventListener('shopify:section:load', run);
})();
